import { HTMLProps } from 'react'
import { cn } from '@src/utils/utils'

export type BaseViewProps = HTMLProps<HTMLDivElement>;

const BaseView = (props: BaseViewProps) => {
  const { className } = props

  const classes = cn('flex flex-col', className || '')

  return (
    <div {...props} className={classes}>
      {props.children}
    </div>
  )
}

export default BaseView
